import { CircularProgress, CircularProgressProps, Grid } from '@mui/material'

export type SpinnerProps = Omit<CircularProgressProps, 'color'>

export const Spinner = ({ ...props }: SpinnerProps) => {
  return <CircularProgress color="secondary" {...props} />
}

export const CenteredSpinner = ({ ...props }: SpinnerProps) => {
  return (
    <Grid container alignItems="center" justifyContent="center" direction="row">
      <Spinner {...props} />
    </Grid>
  )
}
